import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { AppBar, Tabs, Tab, Grid, Icon } from '@mui/material'
import MDBox from 'components/MDBox'
import breakpoints from 'assets/theme/base/breakpoints'
import MDTypography from 'components/MDTypography'

function TabsHeader({ elements }) {
  const [tabsOrientation, setTabsOrientation] = useState('horizontal')
  const [tabValue, setTabValue] = useState(0)

  useEffect(() => {
    function handleTabsOrientation() {
      return window.innerWidth < breakpoints.values.sm
        ? setTabsOrientation('vertical')
        : setTabsOrientation('horizontal')
    }

    window.addEventListener('resize', handleTabsOrientation)
    handleTabsOrientation()
    return () => window.removeEventListener('resize', handleTabsOrientation)
  }, [])

  const handleSetTabValue = (event, newValue) => setTabValue(newValue)

  return (
    <MDBox position="relative" mb={5}>
      <Grid container spacing={3} alignItems="center">
        <Grid item xs={12} md={6} lg={4}>
          <AppBar
            position="static"
            elevation={0}
            sx={{
              backgroundColor: 'transparent',
              boxShadow: 'none',
              borderBottom: '1px solid #e0e0e0',
            }}
          >
            <Tabs
              orientation={tabsOrientation}
              value={tabValue}
              onChange={handleSetTabValue}
              style={{
                backgroundColor: 'transparent',
              }}
              TabIndicatorProps={{
                style: {
                  backgroundColor: '#1976d2', // Blue underline
                  height: '2px',
                },
              }}
              textColor="primary"
              sx={{
                '& .MuiTab-root': {
                  textTransform: 'uppercase',
                  fontWeight: 500,
                  fontSize: '0.875rem',
                  color: '#5f6368',
                  minWidth: 100,
                },
                '& .Mui-selected': {
                  color: '#1976d2',
                },
              }}
            >
              <Tab label={`Agency`} />
              <Tab label={`Sub Account`} />
            </Tabs>
          </AppBar>
        </Grid>
      </Grid>

      <MDBox mt={3}>{elements[tabValue]}</MDBox>
    </MDBox>
  )
}

TabsHeader.propTypes = {
  elements: PropTypes.array.isRequired,
}

export default TabsHeader
